module.exports = __webpack_public_path__ + "img/ios_tutorial03.e0e15f75.jpg";